import { Component, inject, OnInit } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';
import { ConfigurationsService } from '../../../services/configurations.service';
import { GungNotificationService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';
import { catchError, first, of } from 'rxjs';

@Component({
    selector: 'lib-gung-settings-config-offer-view',
    templateUrl: './gung-settings-config-offer-view.component.html',
    styleUrl: './gung-settings-config-offer-view.component.scss',
    standalone: false
})
export class GungSettingsConfigOfferViewComponent extends GungSettingsBaseViewComponent implements OnInit {
  protected configurationsService = inject(ConfigurationsService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);

  offerConfig: any;

  ngOnInit(): void {
    this.configurationsService
      .getConfigurationsByIds(['OfferDbConfig'])
      .pipe(first())
      .subscribe(configs => {
        this.offerConfig = configs?.find(c => c.id === 'OfferDbConfig');
      });
  }

  saveOfferConfig(): void {
    this.configurationsService
      .updateConfiguration(this.offerConfig)
      .pipe(
        first(),
        catchError(() => {
          this.gungNotificationService.notify(
            this.translateService.instant('ERROR'),
            this.translateService.instant('ERROR_SAVING_CONFIGURATION'),
            'error'
          );
          return of(null);
        })
      )
      .subscribe(res => {
        if (!res) return;
        this.gungNotificationService.notify(
          this.translateService.instant('CONFIGURATION_SAVED'),
          this.translateService.instant('OFFER_CONFIGURATION_SAVED_MESSAGE'),
          'success'
        );
      });
  }
}
